import { Injectable } from '@angular/core';
import { Response } from "@angular/http";

import "rxjs/Rx";
import { Subject } from "rxjs/Subject";

import { iResponseInfo } from '../../../interfaces/shared/iResponseInfo';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { environment } from "../../../../environments/environment";
import { AuthService } from "../../auth/auth.service";

@Injectable()
export class VehicleInfoService {

    vehicleInfoChanged = new Subject();

    constructor(private authHttp: AuthHttp,
        private authService: AuthService) { }

    private errorMessage: string = null;
    hasErrors() {
        return this.errorMessage != null;
    }
    getErrorMessage() {
        return this.hasErrors() ? this.errorMessage : "";
    }

    private selectedRegistrationId: number = -1;

    private responseInfo: iResponseInfo = new iResponseInfo();
    private responseInfoForOwners: iResponseInfo = new iResponseInfo();

    private vehicleInfo: any;

    loadVehicleInfo(registrationId: number) {
        this.errorMessage = null;

        let postObj = {
            'registrationId': registrationId,
            'languageId': 1,
            'watchedBy': this.authService.getUser().appUserId,
            'ipAddress': '',
            'emailAddressOfClientAccessing': this.authService.getUser().email
        };

        var qs = environment.apiPath + '/api/enforcement/GetVehicleInfo';

        return this.authHttp.post(qs, postObj)
            .map(
            (response: Response) => {
                return response.json();
            }).subscribe(
            (response: any) => {
                this.responseInfo = new iResponseInfo();

                this.vehicleInfo = response;

                //console.log("load vehicle info from server");

                this.responseInfo.isSuccess = response.responseInfo.isSuccess;
                this.responseInfo.isWarning = response.responseInfo.isWarning;
                this.responseInfo.isError = response.responseInfo.isError;
                this.responseInfo.message = response.responseInfo.message;

                this.responseInfoForOwners.isSuccess = response.responseInfoForOwners.isSuccess;
                this.responseInfoForOwners.isWarning = response.responseInfoForOwners.isWarning;
                this.responseInfoForOwners.isError = response.responseInfoForOwners.isError;
                this.responseInfoForOwners.message = response.responseInfoForOwners.message;

                this.vehicleInfoChanged.next();
            },
            (error) => {
                this.errorMessage = error;
                this.vehicleInfoChanged.next();
            });
    }

    getResponseInfo() {
        return this.vehicleInfo == null ? new iResponseInfo() : this.responseInfo;
    }

    getResponseInfoForOwners() {
        return this.vehicleInfo == null ? new iResponseInfo() : this.responseInfoForOwners;
    }

    clearVehicleInfo(registrationId: number) {
        if (this.selectedRegistrationId != registrationId) {
            this.selectedRegistrationId = registrationId;
            this.vehicleInfo = null;
            this.responseInfo = new iResponseInfo();
            this.responseInfoForOwners = new iResponseInfo();
        }
    }

    getVehicleOwners() {
        return this.vehicleInfo == null ? null : this.vehicleInfo.owners;
    }

    getInfoReport() {
        return this.vehicleInfo == null ? "" : this.vehicleInfo.infoReport;
    }

    getVehicleInfo() {
        return this.vehicleInfo;
    }

    init() {
        this.vehicleInfo = null;
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/nonanon/vehicle/vehicle-info.service.ts